@if (payments && payments.length) {
    <div class="db-payment-history__wrapper">
        @if (paymentMethods?.length || paymentPaypal?.length ) {
            <div class="db-payment-history__header" >
                <h3>{{'text_paymentsHistory' | dbText}}</h3>
                <div class="db-payment-history-pagination">
                    <db-pagination-controls (onChangePage)="onChangePage($event)" [currentPage]="currentPage"
                                            [pagesCount]="pagesCount" [itemsPerPage]="itemsPerPage"
                                            [itemsCount]="payments.length"></db-pagination-controls>
                </div>
            </div>
        }
        <div>
            <div>
                <div class="db-payment-history">
                    <div class="db-payment-history-body">
                        @for (payment of  (payments | sortBy : 'paymentsDate' : 'desc' | pagination : {'currentPage': currentPage,'itemsPerPage': itemsPerPage}); track payment) {
                            <div class="db-payment-history-item">
                                <div><p>{{ 'text_date' | dbText }}</p><p>{{payment.paymentsDate}}</p></div>
                                <div><p>{{ 'text_paymentAmount' | dbText }}</p><p>{{payment.totalAmount}}</p></div>
                                <div class="db-payment-history-card-number">
                                    <p>{{ 'text_paymentMethod' | dbText}}</p>
                                    <div>
                                        @if (payment.paymentStatus !== 'Refunded' && payment.paymentStatus !== 'requires_source_action') {
                                            @if (payment.paymentType === 'card' && payment.paymentStatus !== 'failed') {
                                                <div class="db-payment-card_image {{payment.cardType}}"></div>
                                                <div>&#9679;&#9679;&#9679;&#9679;</div>
                                                <div>{{payment.cardLastNumbers}}</div>
                                            }
                                            @if (payment.paymentStatus === 'failed') {
                                                <div class="db-payment-card_image"></div>
                                                <div class="no-card"><i class="db-icon db-icon-accordion-minus"></i></div>
                                                <div></div>
                                            }

                                            @if (payment.paymentType === 'paypal_recurring' || payment.paymentType === 'paypal') {
                                                <div><img class="paypal-image" src="assets/images/logos/payment/paypal.svg" alt=""/></div>
                                            }
                                        }
                                    </div>
                                </div>
                                <div><p [style.text-transform]="'capitalize'">{{ 'text_status' | dbText }}</p><p>{{payment.paymentStatus}}</p></div>
                                <div class="se-get-invoice db-payment-history__download-pdf">
                                    <p>{{ 'text_invoiceReceipt' | dbText }}</p>
                                    @if ((payment.invoicePath || (companyInfo?.payment_provider?.provider === 'paypal'))
                                    && payment.paymentStatus !== 'Refunded') {
                                        <a class="db-link" (click)="downloadInvoice(payment)">
                                            {{'text_downloadPDF' | dbText}} <span class="db-icon db-icon-download-button"></span>
                                        </a>
                                    }
                                    @if (!((payment.invoicePath || (companyInfo?.payment_provider?.provider === 'paypal'))
                                        && payment.paymentStatus !== 'Refunded')) {
                                        <p>no invoice</p>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}@else {
    <div class="db-no-payment-history">
        <div class="db-no-payment-history-title"><span>Hi!</span></div>
        <div class="db-no-payment-history-desc" ><span [innerHtml]="'text_paymentsHistoryEmpty' | dbText"></span></div>
    </div>
}



